/**
 * returns the number of items in a menu section
 * @param {Object} menuSection
 * @param {[]} menuSection.items
 *
 * @return {number}
 */

export const getMenuSectionLength = menuSection => menuSection.items.length;

/**
 * returns the number of items in a menu
 * @param {Object} menu
 * @param {[]} menu.sections
 *
 * @return {number}
 */
export const getMenuLength = menu =>
  menu.sections.reduce((acc, curr) => {
    return acc + getMenuSectionLength(curr);
  }, 0);
